import WizardScreen from '@/screens/Wizard/WizardScreen';

/** Post-map intake (שאלון) — venture, contact, review, consent before assessment (חיווי). */
export default function QuestionnaireScreen() {
  return <WizardScreen flow="journey" />;
}
